import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { setConfiguration } from 'react-grid-system'

import Header from './components/Header'
import Footer from './components/Footer'

import Main from './pages/Main'
import WorkWithUs from './pages/WorkWithUs'
import Developers from './pages/Developers'
import Customers from './pages/Customers'
import References from './pages/References'
import About from './pages/About'
import Contact from './pages/Contact'

import GlobalStyle from './globalStyles.ts'

import { UIStore } from './stores/UIStore'

const App = observer(() => {
  setConfiguration({
    breakpoints: [576, 768, 992, 1280],
    containerWidths: [540, 750, 960, 1220],
  })

  return (
    <div style={{ backgroundColor: UIStore.backgroundShade }}>
      <GlobalStyle />
      <Router>
        <Header />
        <PageWrapper>
          <Switch>
            <Route exact path="/" render={() => <Main />} />
            <Route exact path="/work" render={() => <WorkWithUs />} />
            <Route exact path="/developers" render={() => <Developers />} />
            <Route exact path="/customers" render={() => <Customers />} />
            <Route exact path="/references" render={() => <References />} />
            <Route exact path="/about" render={() => <About />} />
            <Route exact path="/contact" render={() => <Contact />} />
          </Switch>
        </PageWrapper>
        <Footer />
      </Router>
    </div>
  )
})

const PageWrapper = styled.div`
  padding: 0;
  margin-bottom: 425px;

  @media (min-width: 769px) {
    margin-bottom: 535px;
  }
`

export default App
